module.exports = __webpack_public_path__ + "img/collaborate-detail-2.5a2bfff3.png";